<template>
    <Paper class="p-4" :class="{ pointer: this.routerLink }">
        <div class="d-flex flex-column" @click="click">
            <div class="d-flex flex-row justify-content-center mb-3">
                <img :src="company.logo" class="logo" />
            </div>
            <div class="companytitle">{{ company.title }}</div>
        </div>
    </Paper>
</template>

<script>
export default {
    name: 'CompanyBadge',
    props: {
        company: {
            type: Object,
            default: {},
        },
        routerLink: {
            type: String,
            default: '',
        },
    },
    methods: {
        click() {
            if (this.routerLink) {
                this.$router.push(this.routerLink);
            }
        },
    },
};
</script>

<style scoped>
.logo {
    width: 180px;
    height: 70px;
    object-fit: contain;
}
.companytitle {
    font-size: 18px;
    text-align: center;
}
.pointer {
    cursor: pointer;
}
</style>
